import ProjectPaymentActivationPage from "../../shared/project-payment-activation/ProjectPaymentActivationPage";

const SolarentOperatorProjectPaymentActivationPage = () => (
  <ProjectPaymentActivationPage source="SolarentOperator" />
);

export default SolarentOperatorProjectPaymentActivationPage;
